import {useDomain} from "snimf/domain/provider";
import {FormSelectMultiple} from "base/form/components";

const PermitApplicationTypesFormField = ({extension = null, disabled = false}) => {
    const {permitTypeDomain} = useDomain();

    const options = !extension
        ? permitTypeDomain
        : permitTypeDomain.filter(type =>
              extension?.permit?.types.includes(type.value)
          );

    return (
        <FormSelectMultiple
            name="types"
            label={extension ? "Guias para prorrogar" : "Guias da autorização"}
            options={options}
            rules={{required: "Este campo é obrigatório."}}
            disabled={disabled}
        />
    );
};

export default PermitApplicationTypesFormField;
